import { Component, inject, OnInit, signal } from "@angular/core";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from "@angular/material/sidenav";
import { NavigationEnd, Router } from "@angular/router";
import { TopbarComponent } from "@lib/base/components/navigation/topbar/topbar.component";
import { WindowLayoutDirective } from "@lib/base/directives/window-layout.directive";
import { ResizeWindowService } from "@lib/base/services/resize-window.service";
import { filter, withLatestFrom } from "rxjs";
import { fadeInAnimation } from "../../../animations/fade-in";

@Component({
    selector: "app-sidenav",
    imports: [
        MatSidenavContainer,
        MatSidenavContent,
        MatSidenav,
        MatIcon,
        MatIconButton,
        TopbarComponent,
    ],
    templateUrl: "./sidenav.component.html",
    styleUrl: "./sidenav.component.scss",
    animations: [fadeInAnimation],
    hostDirectives: [WindowLayoutDirective],
})
export class SidenavComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly resizeWindowService = inject(ResizeWindowService);

    protected readonly isMobileMode = this.resizeWindowService.isMobile;

    protected readonly isOpened = signal<boolean>(window.innerWidth >= 1280);
    protected readonly sidenavMobileMode = signal<boolean>(window.innerWidth < 1280);

    subs = this.isMobileMode.subscribe((isMobile) => {
        if (isMobile) {
            this.isOpened.set(false);
            setTimeout(() => {
                this.sidenavMobileMode.set(true);
            }, 500);
        } else {
            this.sidenavMobileMode.set(false);
            setTimeout(() => {
                this.isOpened.set(true);
            }, 500);
        }
    });

    ngOnInit() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            withLatestFrom(this.resizeWindowService.isMobile),
            filter(([_, isMobile]) => isMobile),
        ).subscribe((_) => {
            this.isOpened.set(false);
        });
    }
}
